import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useSession } from '../lib/session';
import '../styles/documents.css';

interface AuditEvent {
  id: string;
  action: string;
  entityType: string | null;
  entityId: string | null;
  summary: string | null;
  actor: string;
  createdAt: string | null;
}

const ACTION_TONE = (action: string): string => {
  if (action.includes('void') || action.includes('reject') || action.includes('delete')) return 'var(--clay)';
  if (action.includes('correct') || action.includes('plan_changed')) return 'var(--amber)';
  if (action.includes('applied') || action.includes('sign') || action.includes('approve') || action.includes('paid')) return 'var(--accent)';
  return 'var(--line-strong)';
};

export function Audit() {
  const { company } = useSession();
  const nav = useNavigate();
  const [events, setEvents] = useState<AuditEvent[] | null>(null);

  useEffect(() => {
    if (!company) return;
    setEvents(null);
    api.get<AuditEvent[]>('/audit?limit=150').then(setEvents).catch(() => setEvents([]));
  }, [company]);

  const fmt = (iso: string | null): string => {
    if (!iso) return '—';
    const d = new Date(iso);
    return d.toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <main className="main">
      <div className="page-head">
        <div className="page-head__title">
          <span className="eyebrow">Administration</span>
          <h1 className="h1">Audit</h1>
          <p className="page-head__sub">Every effective action is recorded: who, what and when. The trail cannot be altered.</p>
        </div>
      </div>

      <div className="card">
        <div className="card__body">
          {!events && <div className="empty">Loading…</div>}
          {events && events.length === 0 && <div className="empty">Sin eventos registrados.</div>}
          {events && events.length > 0 && (
            <div className="timeline">
              {events.map((e) => (
                <div key={e.id} className="timeline__item">
                  <div className="timeline__head">
                    <span className="timeline__title row center gap-8">
                      <span style={{ width: 7, height: 7, borderRadius: '50%', background: ACTION_TONE(e.action), display: 'inline-block', flexShrink: 0 }} />
                      {e.summary ?? e.action}
                    </span>
                    <span className="timeline__date">{fmt(e.createdAt)}</span>
                  </div>
                  <div className="timeline__body">
                    <span className="faint">{e.actor}</span>
                    {e.entityType === 'document' && e.entityId && (
                      <button
                        style={{ marginLeft: 10, color: 'var(--accent)', fontWeight: 500, fontSize: 12.5 }}
                        onClick={() => nav(`/documentos/${e.entityId}`)}
                      >
                        ver documento →
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
